/**
 * String helper utility class
 */
export class StringUtilities {

    /** Used to map HTML entities to characters. */
    private static htmlUnescapes: { [key: string]: string } = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    }

    private static reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g

    private static reHasEscapedHtml = RegExp(StringUtilities.reEscapedHtml.source);

    public static b64Encode(source: string): string {
        return btoa(encodeURIComponent(source)
            .replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode(Number('0x' + p1))));
    }

    public static b64Decode(source: string): string {
        return decodeURIComponent(atob(source)
            .split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
    }

    /**
     * The inverse of `escape`this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;` and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @see escape, escapeRegExp
     * @example
     *
     * unescape('fred, barney, &amp; pebbles')
     * // => 'fred, barney, & pebbles'
     */
    public static unescape(string: string): string {
        return (string && StringUtilities.reHasEscapedHtml.test(string))
            ? string.replace(StringUtilities.reEscapedHtml, (entity) => StringUtilities.htmlUnescapes[entity])
            : string
    }

    /**
     * whatItDoes
     * removes html tags from string
     */
    public static stripTags(string: string): string {
        return string.replace(/(<([^>]+)>)/gi, "");
    }

}
